export const OOTB_AGENTS_BY_PRODUCT = {
	'atlassian-studio': [
		'jsm_service_triage_agent',
		'product_requirements_guide_agent',
		'customer_insights_agent',
	],
	jira: ['readiness_checker_agent', 'jira_theme_analyzer_agent', 'bug_report_assistant_agent'],
	'jira-service-management': [
		'jsm_service_triage_agent',
		'ops_guide_agent',
		'bug_report_assistant_agent',
	],
	confluence: [
		'product_requirements_guide_agent',
		'customer_insights_agent',
		'transcript_insights_reporter_agent',
	],
	default: [
		'jsm_service_triage_agent',
		'product_requirements_guide_agent',
		'customer_insights_agent',
	],
} as const;

export const RECOMMENDED_AGENTS_COUNT = 6;

export const FALLBACK_OOTB_AGENTS_BY_PRODUCT: Readonly<Record<string, readonly string[]>> = {
	jira: [
		'readiness_checker_agent',
		'issue_organizer_agent',
		'bug_report_assistant_agent',
		'work_item_planner_agent',
		'blocker_checker_agent',
		'jira_theme_analyzer_agent',
		'progress_tracker_agent',
		'release_notes_drafter_agent',
	],
	'jira-service-management': [
		'jsm_service_triage_agent',
		'jsm_service_agent',
		'ops_guide_agent',
		'bug_report_assistant_agent',
		'blocker_checker_agent',
		'customer_insights_agent',
		'readiness_checker_agent',
		'comms_crafter_agent',
	],
	confluence: [
		'product_requirements_guide_agent',
		'release_notes_drafter_agent',
		'comms_crafter_agent',
		'brand_voice_crafter_agent',
		'decision_director_agent',
		'global_translator_agent',
		'transcript_insights_reporter_agent',
		'customer_insights_agent',
	],
	rovo: [
		'customer_insights_agent',
		'transcript_insights_reporter_agent',
		'progress_tracker_agent',
		'jira_theme_analyzer_agent',
		'okr_generator_agent',
		'comms_crafter_agent',
		'release_notes_drafter_agent',
		'rovo_expert_agent',
	],
	default: [
		'work_item_planner_agent',
		'okr_generator_agent',
		'product_requirements_guide_agent',
		'customer_insights_agent',
		'jsm_service_triage_agent',
		'transcript_insights_reporter_agent',
		'release_notes_drafter_agent',
		'comms_crafter_agent',
	],
} as const;
